import '@/stores/store';
import './global.css';

import NiceModal from '@ebay/nice-modal-react';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { StillnessProvider } from 'react-stillness-component';

import { FIRST_RECHARGE_DAILY_FIRST_ENTER } from '@/constant/config';
import Router from '@/routers/routers';
import Storage from '@/utils/Storage';

import { implog } from './api/implog';
import useDevice from './hooks/useDevice';
import useRefreshModalInOnactive from './hooks/useRefreshModal';
import { useSetBody } from './hooks/useSetBody';
import { invoke } from './utils/apk';
import { getChannelFlag, isInFacebookBrowser, isPwaSource } from './utils/utils';

document.onreadystatechange = function () {
  if (document.readyState == 'complete') {
    // 页面加载完毕
    const source = getAPKCHSource().replace('CH_', '');
    if (!window.localStorage.getItem(`hall_load_end_loading_${source}`)) {
      const diff = Date.now() - window.performance.timing.navigationStart;
      const fbclid = new URLSearchParams(window.location.search).get('fbclid') || '';
      implog('first_hall_load_end', diff.toString(), fbclid);
      window.localStorage.setItem(`hall_load_end_loading_${source}`, '1');
    }
  }
};

function App() {
  useSetBody();
  useRefreshModalInOnactive();
  const { isAndroid } = useDevice();

  if (isPwaSource() && isAndroid && isInFacebookBrowser()) {
    try {
      const url = encodeURIComponent(window.location.origin);
      window.location.href = `intent://open/#Intent;scheme=chrome;package=com.android.chrome;S.browser_fallback_url=${url};end`;
    } catch (e: any) {
      console.log('error' + e.message);
    }
  }
  const source = getAPKCHSource().toLocaleLowerCase();
  const flag = getChannelFlag();

  let basename = '';
  if (source && flag) {
    basename = `/${source}/${flag}`;
  }
  const reg = /\/ch_h5[^/]*\/\d{6}(.*)/;
  const pathname = window.location.pathname.toLocaleLowerCase();
  if (pathname !== '/' && !reg.test(pathname)) {
    window.location.href = `${window.location.origin}${window.location.search}`;
  }

  useEffect(() => {
    const handleAppVisibleChange = () => {
      if (document.hidden) return;
      const dailyFirstTime = Storage.get(FIRST_RECHARGE_DAILY_FIRST_ENTER);
      if (!dailyFirstTime) {
        Storage.set(FIRST_RECHARGE_DAILY_FIRST_ENTER, {
          last: dayjs().format('YYYY-MM-DD HH:mm:ss')
        });
        return;
      }
      const date = dayjs(dailyFirstTime.last).get('date');
      const curDate = dayjs().get('date');
      if (date === curDate) return;
      // 两小时内不在触发
      const diff = dayjs().diff(dayjs(dailyFirstTime.last)) / (1000 * 60 * 60);
      if (diff < 2) {
        return;
      }
      Storage.set(FIRST_RECHARGE_DAILY_FIRST_ENTER, {
        last: dayjs().format('YYYY-MM-DD HH:mm:ss')
      });
    };
    handleAppVisibleChange();

    invoke();

    document.addEventListener('visibilitychange', handleAppVisibleChange);
    return () => {
      document.removeEventListener('visibilitychange', handleAppVisibleChange);
    };
  }, []);

  return (
    <HelmetProvider>
      <StillnessProvider>
        <BrowserRouter basename={basename}>
          <NiceModal.Provider>
            <Router />
          </NiceModal.Provider>
        </BrowserRouter>
      </StillnessProvider>
    </HelmetProvider>
  );
}

export default App;
